import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { FeatureToggle } from 'shared/data-objects/feature-toggle';
import { ServiceBase } from './service-base';

@Injectable()
export class FeatureToggleService extends ServiceBase {

  features?: FeatureToggle;

  constructor(private httpClient: HttpClient) {
    super();
  }

  getFeatures(): Observable<FeatureToggle> {
    return this.httpClient.get<FeatureToggle>(ServiceBase.baseHref + '/feature-toggle');
  }

  async fetchFeatureToggles() {
    return new Promise((rs, rj) => {
      if (this.features) {
        rs(this.features);
      } else {
        const promise = this.httpClient.get<FeatureToggle>(ServiceBase.baseHref + '/feature-toggle').toPromise();
        promise.then(
          d => { this.features = d; rs(d); },
          e => rj(e)
        );
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/feature-toggle.service.ts